<template>
    <div class="p-grid p-mx-auto p-text-center p-mt-1">
        <div class="p-col-3"></div>
        <div class="p-col-6 p-md-6 p-text-center">
            <Button label="&lt;&lt;" class="p-button-text p-button-info" @click="changeDate(-1)" />
            <label for="search_date"></label>
            <Calendar id="search_date" v-model="search.date" dateFormat="dd-mm-yy"
                :key="calendarComponentKey" @date-select="dateSelected()" />
            <Button label="&gt;&gt;" class="p-button-text p-button-info" @click="changeDate(+1)" />
        </div>
    </div>

    <div class="p-col-11 p-grid p-mx-auto p-mt-4">
        <div class="p-col-12 p-md-3">
            <Listbox v-model="tournaments.selected"
                    v-show="tournaments.items !== null && tournaments.items.length > 0"
                    :disabled="tournaments.isLoading"
                    :options="tournaments.items"
                    optionLabel="label"
                    :filter="false"
                    class="p-text-left"
                    @change="categorySelected()"
                    listStyle="max-height: 55%; overflow-y: auto;" />
            <p v-show="tournaments.items === null || tournaments.items.length === 0">
                No available category found for selected date.
            </p>
        </div>
        <div class="p-col-12 p-md-5" v-show="tournaments.selected !== undefined && tournaments.selected !== null">
            <Listbox v-model="events.selected"
                v-show="!tournaments.isLoading && events.items !== null && events.items.length > 0"
                :disabled="tournaments.isLoading && events.isLoading"
                :options="events.items"
                :filter="true"
                class="p-text-left"
                @change="eventSelected()">
                <template #option="event">
                    <div :class="event.option.text_class">
                        {{event.option.event_info}}
                    </div>
                </template>
            </Listbox>
        </div>
        <div class="p-col-12 p-md-3" 
            v-show="!tournaments.isLoading && !events.isLoading && events.selected !== undefined && events.selected !== null">
            <i>{{notifications.title}}</i>
            <div class="" style="max-height: 55%; overflow-y: auto;">
                <div v-for="(notification) in notifications.items" :key="notification.id" class="p-p-2 p-mb-1 box">
                    <p class="p-text-left">
                        <b>{{notification.title}}</b> <br/>
                        {{notification.subtitle}}
                    </p>
                    <p class="p-text-left">
                        <small>Success/Failure/Total:
                            {{notification.successCount}} / 
                            {{notification.failureCount}} / 
                            {{notification.fcmTokenCount}}
                        </small>
                    </p>
                </div>
            </div>
        </div>
    </div>

</template>

<style>
.status_tracking {
    color: rgb(33, 222, 71);
}
.status_completed {
    color: rgb(135, 135, 135);
}
.event_ss_br_unmatched, .event_ss_mk_unmatched {
    color: rgb(238, 23, 23);
}
</style>

<script>
import axios from "axios";
import Calendar from 'primevue/calendar'
import Button from 'primevue/button'
import Listbox from 'primevue/listbox'

let SpringApi;

export default {
    name: 'Trackable Events Schedule',
    components: {
        Calendar,
        Button,
        Listbox,
    },
    emits: ["loginResult", "pageLoaded"],
    data() {
        return {
            search: {
                date: new Date()
            },
            trackableTournamentCategoryIds: [],
            trackableUniqueTournamentIds: [],
            tournaments: {
                isLoading: false,
                items: [],
                selected: null,
            },
            events: {
                isLoading: false,
                items: [],
                selected: null,
            },
            notifications: {
                isLoading: false,
                items: [],
                selected: null,
                title: null
            },
            calendarComponentKey: 0
        }
    },
    beforeMount() {
        SpringApi = axios.create({
            baseURL : process.env.VUE_APP_SPRING_API_URL,
            headers: {
                'Authorization': 'Bearer ' + this.$cookies.get('token')
            }
        });

        var page = {
            title: 'Trackable Events Schedule'
        }
        this.$emit('pageLoaded', page)
    },
    async mounted() {
        await this.loadTrackableTournaments()
    },
    methods: {
        async loadTrackableTournaments() {
            let response = await SpringApi.get(`/trackable-tournaments`);
            this.trackableTournamentCategoryIds = [...new Set(response.data.map(tournament => tournament.ss_category_id))];
            this.trackableUniqueTournamentIds = [...new Set(response.data.map(tournament => tournament.ss_unique_tournament_id))];

            this.dateSelected();
        },
        changeDate(change) {
            this.search.date.setDate(this.search.date.getDate() + change);
            this.dateSelected();
            this.calendarComponentKey += 1; // used to update calendar component ui
        },
        dateSelected() {
            this.loadCategories();
        },
        dateToYMD(date) {
            var d = date.getDate();
            var m = date.getMonth() + 1; //Month from 0 to 11
            var y = date.getFullYear();
            return '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
        },
        async loadCategories() {
            this.tournaments.isLoading = true;
            this.events.items = [];
            this.events.selected = null;
            this.notifications.items = [];

            let searchDateStr = this.dateToYMD(this.search.date);

            let ssCategoriesByDate = await SpringApi.get('/ssevents/categories/'+searchDateStr);
            let ssCategories = ssCategoriesByDate.data.categories.filter(ssCategory => this.trackableTournamentCategoryIds.includes(ssCategory.category.id));
            ssCategories.forEach(ssCategory => {
                ssCategory.label = ssCategory.category.name + ' ('+ssCategory.totalEvents+')';
            });

            let categoryIdTurkey = 46;
            let categoryIdEurope = 1465;
            let categoryIdWorld = 1468;

            var categories = ssCategories.filter(ssCategory => ![categoryIdTurkey, categoryIdEurope, categoryIdWorld].includes(ssCategory.category.id));
            
            let turkey = ssCategories.find(ssCategory => ssCategory.category.id === categoryIdTurkey)
            let europe = ssCategories.find(ssCategory => ssCategory.category.id === categoryIdEurope)
            let world = ssCategories.find(ssCategory => ssCategory.category.id === categoryIdWorld)

            if (world !== undefined && world !== null) { categories.unshift(world) }
            if (europe !== undefined && europe !== null) { categories.unshift(europe) }
            if (turkey !== undefined && turkey !== null) { categories.unshift(turkey) }
            
            this.tournaments.items = [...new Set(categories)];
            this.tournaments.isLoading = false;
        },
        async categorySelected() {
            const formatNumber = number => number.toLocaleString();
            let selectedCategory = this.tournaments.selected
            let selectedCategoryId = selectedCategory.category.id
            let searchDateStr = this.dateToYMD(this.search.date);
            
            this.events.isLoading = true;
            this.events.items = [];
            this.events.selected = null;
            this.notifications.items = [];

            let ssEventsByDate = await SpringApi.get('/ssevents/category/'+selectedCategoryId+'/scheduled-events/'+searchDateStr);
            let eventPairsByDate = await SpringApi.get('/ssevents/by-date/'+searchDateStr)
            console.log(eventPairsByDate.data)

            let events = ssEventsByDate.data.events;
            events.forEach(element => {
                // event_pairs kaydı varsa bularak eşleştir
                element.event_pairs = eventPairsByDate.data.find(eventPairs => eventPairs.ssEventId === element.id)
                
                var homeTeamName = element.homeTeam.name, awayTeamName = element.awayTeam.name
                
                // (varsa) event_pairs kaydından takım adlarını, subsDeviceCount ve trackingStatus değerlerini getir
                var subscribedDeviceInfo = ''
                var warningPrefix = ''
                var warningPostfix = ''
                if (element.event_pairs !== null && element.event_pairs !== undefined) {
                    homeTeamName = element.event_pairs.ssHomeTeamName
                    awayTeamName = element.event_pairs.ssAwayTeamName
                    subscribedDeviceInfo = ' ('+formatNumber(element.event_pairs.subscribedDeviceCount)+' device)'
                    
                    // maç bitti veya canlı durumu için class belirle (gri veya yeşil renk)
                    var trackStatus = element.event_pairs.trackStatus
                    if (trackStatus !== undefined && trackStatus !== null) {
                        if (trackStatus === 'tracking') {
                            element.text_class = 'status_tracking'
                        } else if (trackStatus === 'completed') {
                            element.text_class = 'status_completed'
                        }
                    }

                    if (element.event_pairs.mkMatchId === undefined || element.event_pairs.mkMatchId === null) {
                        warningPrefix = '❌ 🆘 ';
                        element.text_class = 'event_ss_mk_unmatched'
                    } else {
                        var homePairEmoji = element.event_pairs.mkIsHomePaired ? '✅' : '🟠'
                        var awayPairEmoji = element.event_pairs.mkIsAwayPaired ? '✅' : '🟠'
                        warningPostfix += '\n' + element.event_pairs.mkHomeTeamName + ' ' + homePairEmoji 
                            + ' - ' + element.event_pairs.mkAwayTeamName + ' ' + awayPairEmoji
                    }

                    if (element.event_pairs.brEventStartTimestamp !== undefined && element.event_pairs.brEventStartTimestamp !== null
                        && element.event_pairs.ssEventStartTimestamp !== element.event_pairs.brEventStartTimestamp) {
                        let brStartDate = new Date(element.event_pairs.brEventStartTimestamp * 1000);
                        warningPostfix += ' ⏰ ⏰  BR Time: ' + brStartDate.toLocaleTimeString().substr(0, 5) + ' '
                    }
                }
                
                // event label oluştur
                element.event_info = `${homeTeamName} - ${awayTeamName}`
                if (element.homeScore !== undefined && element.homeScore !== null && element.homeScore.current !== undefined
                    && element.awayScore !== undefined && element.awayScore !== null && element.awayScore.current !== undefined) {
                    element.event_info = `${homeTeamName} ${element.homeScore.current} - ${element.awayScore.current} ${awayTeamName}`
                }

                // maç başlama saatini tarayıcı local saatine göre ayarlayıp ekle
                let eventStartDate = new Date(element.startTimestamp * 1000);
                element.event_info = eventStartDate.toLocaleTimeString().substr(0, 5) + ' ' + element.event_info;

                // warning ve subscribed device infoları ekle
                element.event_info = warningPrefix + element.event_info + subscribedDeviceInfo + warningPostfix
            });
            
            this.events.items = events.filter(event => {
                let eventDate = new Date(event.startTimestamp * 1000);
                let eventDateStr = this.dateToYMD(eventDate);
                let searchDateStr = this.dateToYMD(this.search.date);

                return eventDateStr === searchDateStr
                    && event.tournament.uniqueTournament !== null
                    && event.tournament.uniqueTournament !== undefined
                    && this.trackableUniqueTournamentIds.includes(event.tournament.uniqueTournament.id)
            });

            console.log(this.events)
            this.events.isLoading = false;
        },
        async eventSelected() {
            let event = this.events.selected;
            let ssEventId = event.id;
            
            this.notifications.isLoading = true;
            let response = await SpringApi.get('/notifications/by-event/'+ssEventId);
            this.notifications.items = response.data;

            this.notifications.isLoading = false;
            
            var title = 'No notification sent!'
            if(this.notifications.items !== null && this.notifications.items.length > 0) {
                if (this.notifications.items.length > 1) {
                    title = this.notifications.items.length + ' notifications sent'
                } else {
                    title = '1 notification sent'
                }
            }
            this.notifications.title = title
        }
    }
}
</script>
